<template>
  <!--  -->
  <div>
    <!--  -->
    <div class="flex-grow flex flex-col m-2 p-4 bg-white border-t border-b sm:rounded-lg sm:border shadow-custom overflow-hidden" >
      <!--  -->
      <div class="flex flex-wrap items-center">
        <!--  -->
        <div class="relative w-full  max-w-full flex-grow flex-1">
          <!--  -->
          <h3 class="font-bold text-base text-gray-800">
            {{ titledelivery }}
          </h3>
          <!--  -->
        </div>
        <!--  -->
        <div @click="openFilter = !openFilter" title="Filter" class="flex items-center cursor-pointer justify-center rounded-full p-2 bg-gray-300" >
          <!--  -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
          </svg>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div v-if="openFilter" class="flex-auto grid gap-4  mt-5" :class=" userTypedelivery && userTypedelivery != 'Seller' && filter && timeserchtype == 'betweendate'   ? 'grid-cols-3'   : 'grid-cols-2' ">
        <!--  -->
        <div v-if="userTypedelivery && userTypedelivery != 'Seller'" class="border h-10 hover:border-orange-500  focus-within:border-orange-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
          <!--  -->
          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
            <!--  -->
            <p>
              <!--  -->
              <label for="category" class="bg-white text-gray-700 px-1">
                {{ $t('seller') }} :
                <span :class="$colors.required">*</span>
              </label>
              <!--  -->
            </p>
            <!--  -->
          </div>
          <!--  -->
          <p>
            <!--  -->
            <v-select v-model="timeserchseller" :options="sellers" label="company" :placeholder="$t('Seller ...')" @input="ChangeSellerDelivery($event, 'Seller')"></v-select>
            <!--  -->
          </p>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="border h-10 hover:border-orange-500  focus-within:border-orange-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
          <!--  -->
          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
            <!--  -->
            <p>
              <!--  -->
              <label for="category" class="bg-white text-gray-700 px-1">
                {{ $t('product') }} :
                <span :class="$colors.required">*</span>
              </label>
              <!--  -->
            </p>
            <!--  -->
          </div>
          <!--  -->
          <p>
            <!--  -->
            <v-select @search="getProducts($event, 'storeino')" @input="ChangeSellerDelivery($event, 'product')" label="name" :placeholder="$t('Product name')" :options="products" v-model="productdata" :disabled="!timeserchseller"></v-select>
            <!--  -->
          </p>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div v-if=" timeserchseller &&   timeserchseller._id &&   timeserchseller._id.toString() === '64d60cfc05f818068c8f4750'" class="border h-10 hover:border-orange-500  focus-within:border-orange-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
          <!--  -->
          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
            <!--  -->
            <p>
              <!--  -->
              <label for="category" class="bg-white text-gray-700 px-1">
                {{ $t('Affiliate stores') }} :<span :class="$colors.required">*</span>
              </label>
              <!--  -->
            </p>
            <!--  -->
          </div>
          <!--  -->
          <p>
            <!--  -->
            <v-select  @input="ChangeSellerDelivery($event, 'stores')"  :placeholder="$t('Select affiliate store')"  :options="stores"  v-model="affiliate_stores"  :disabled="!timeserchseller"></v-select>
          </p>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div v-if="userTypedelivery && userTypedelivery != 'Seller'" class="border h-10 hover:border-orange-500  focus-within:border-orange-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
          <!--  -->
          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
            <!--  -->
            <p>
              <!--  -->
              <label for="courier" class="bg-white text-gray-700 px-1">{{ $t('courier') }} : 
                <!--  -->
                <span :class="$colors.required">*</span>
                <!--  -->
              </label>
              <!--  -->
            </p>
            <!--  -->
          </div>
          <!--  -->
          <p>
            <!--  -->
            <v-select v-model="timeserchcourier" :options="couriers" label="fullName" :placeholder="$t('Courier ...')" @input="ChangeSellerDelivery($event, 'Courier')"></v-select>
            <!--  -->
          </p>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="border h-10 hover:border-orange-500  focus-within:border-orange-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
          <!--  -->
          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
            <!--  -->
            <p>
              <!--  -->
              <label for="category" class="bg-white text-gray-700 px-1">{{ $t('prices') }} : 
                <!--  -->
                <span :class="$colors.required">*</span>
                <!--  -->
              </label>
              <!--  -->
            </p>
            <!--  -->
          </div>
          <!--  -->
          <p>
            <!--  -->
            <v-select @input="ChangeSellerDelivery($event, 'prices')" :placeholder="$t('Prices ...')" :options="prices" v-model="pricedata" :disabled="!productdata"></v-select>
            <!--  -->
          </p>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="border hover:border-orange-500  w-full focus-within:border-orange-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
          <!--  -->
          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
            <!--  -->
            <p>
              <!--  -->
              <label for="status" class="bg-white text-gray-700 px-1">{{ $t('date') }} :
                <!--  -->
                <span :class="$colors.required">*</span>
                <!--  -->
              </label>
              <!--  -->
            </p>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <p>
            <!--  -->
            <select  id="type"  autocomplete="type"  @change="ChangeTypeDateDelivery($event)"  v-model="timeserchtype"  class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
              <!--  -->
              <option class="bg-white text-gray-600" value="All">
                {{ $t('all') }}
              </option>
              <!--  -->

              <!--  -->
              <option class="bg-white text-gray-600" value="today">
                {{ $t('today') }}
              </option>
              <!--  -->

              <!--  -->
              <option class="bg-white text-gray-600" value="thisweek">
                {{ $t('this_week') }}
              </option>
              <!--  -->

              <!--  -->
              <option class="bg-white text-gray-600" value="lastweek">
                {{ $t('last_week') }}
              </option>
              <!--  -->

              <!--  -->
              <option class="bg-white text-gray-600" value="thismonth">
                {{ $t('this_month') }}
              </option>
              <!--  -->

              <!--  -->
              <option class="bg-white text-gray-600" value="lastmonth">
                {{ $t('last_month') }}
              </option>
              <!--  -->

              <!--  -->
              <option class="bg-white text-gray-600" value="thisyear">
                {{ $t('this_year') }}
              </option>
              <!--  -->

              <!--  -->
              <option value="betweendate" class="bg-white text-gray-600">
                {{ $t('between_two_date') }}
              </option>
              <!--  -->
            </select>
            <!--  -->
          </p>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div v-if="filter && timeserchtype == 'betweendate'" class="inline-block">
          <!--  -->
          <div class="inline-block w-2/5 pr-1">
            <!--  -->
            <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="date" class="bg-white text-gray-700 px-1">From 
                    <!--  -->
                    <span class="text-orange-500">*</span>
                    <!--  -->
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
              <p>
                <!--  -->
                <input v-model="fromDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="from" type="date" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="inline-block w-2/5 pr-1">
            <!--  -->
            <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="date" class="bg-white text-gray-700 px-1">To 
                    <!--  -->
                    <span class="text-orange-500">*</span>
                    <!--  -->
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
              <p>
                <!--  -->
                <input v-model="toDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="to" type="date"/>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="inline-block  w-1/5 pr-1">
            <!--  -->
            <button @click="FindRecordShippings()" :disabled="fromDate == null || toDate == null" class="w-full px-2 py-2 text-white font-light tracking-wider bg-gray-900 rounded">
              Find
            </button>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="flex flex-wrap justify-center">
        <!--  -->
        <div class="w-full sm:w-1/2 sm:pl-2 pt-5 items-center flex">
          <!--  -->
          <div class="relative" style="position: relative;">
            <!--  -->
            <canvas :id="iddelivery" style="height: 215px"></canvas>
            <!--  -->
            <div class="absolute" style="top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 24px;">
              {{ deliveredPercentage }}%
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
        <div class="w-full sm:w-1/2  px-2 pt-5">
          <!--  -->
          <div v-for="(item, index) in dataDelivery" :key="index" class="container" id="alertbox">
            <!--  -->
            <div class="container flex items-center justify-between text-sm border-b font-bold px-4 py-3 relative" role="alert">
              <!--  -->
              <div>
                <!--  -->
                <i style="font-size: 15px;" :class="[ item.name === 'refused' ? 'text-refused' : '', item.name === 'cancelled' ? 'text-red-500' : '', item.name === 'delivered' ? 'text-primary-500' : '', item.name === 'unreachable' ? 'text-unrach' : '', item.name === 'shipped' ? 'text-orange-500' : '', item.name === 'postponed' ? 'text-orange-400' : '',]" class="material-icons" >
                  fiber_manual_record
                </i>
                <!--  -->
                Total {{ item.name }} :
                <!--  -->
              </div>
              <!--  -->
              <p class="font-light">{{ item.count }}</p>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
          <h1 class="text-center pt-2  font-semibold text-black-600">
            Total Shippings : {{ count }}
          </h1>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
import Chart from 'chart.js';

export default {
  props: [
    'dataDelivery',
    'sellers',
    'couriers',
    'options',
    'labelstringd',
    'timeserchd',
    'timeserchsellerdelivery',
    'timeserchcourierdelivery',
    'timeserchsaffiliate_storesdelivery',
    'iddelivery',
    'titledelivery',
    'typedelivery',
    'userTypedelivery',
    'filter',
    'count',
    'from',
    'to',
    'products',
    'prices',
    'stores',
    'product',
    'price',
    'currentUser',
  ],
  data() {
    return {
      myChart: '',
      timeserchtype: this.timeserchd,
      timeserchseller: this.timeserchsellerdelivery,
      timeserchcourier: this.timeserchcourierdelivery,
      productdata: this.product,
      pricedata: this.price,
      fromDate: this.from,
      toDate: this.to,
      openFilter: false,
      affiliate_stores: this.timeserchsaffiliate_storesdelivery,
    };
  },
  watch: {
    Labels: function() {
      if (this.myChart != null) {
        this.myChart.destroy();
      }
      this.drawChart(this.dataDelivery, this.labelstringd);
    },
    dataDelivery: function() {
      if (this.myChart != null) {
        this.myChart.destroy();
      }
      this.drawChart(this.dataDelivery, this.labelstringd);
    },
    labelstringd: function() {
      if (this.myChart != null) {
        this.myChart.destroy();
      }
      this.drawChart(this.dataDelivery, this.Labels, this.labelstringd);
    },
    timeserchsellerdelivery: function() {
      this.timeserchseller = this.timeserchsellerdelivery;
    },
    product: function() {
      this.productdata = this.product;
    },
    price: function() {
      this.pricedata = this.price;
    },
  },
  async mounted() {
    await this.drawChart(this.dataDelivery, this.labelstringd);
    if (
      this.currentUser &&
      this.currentUser.role &&
      this.currentUser.role.name == 'Seller' &&
      this.currentUser.type == 'Seller'
    )
      this.timeserchseller = this.currentUser;
  },
  computed: {
    deliveredPercentage() {
      const delivered = this.dataDelivery.find(item => item.name === "delivered");
      const deliveredCount = delivered ? delivered.count : 0;

      const totalCount = this.dataDelivery.reduce((acc, item) => acc + item.count, 0);

      const percentage = totalCount > 0 ? (deliveredCount / totalCount) * 100 : 0;

      return Math.round(percentage);
    }
  },
  methods: {
    FindRecordShippings: function() {
      this.$emit('FindRecordShippings', this.fromDate, this.toDate);
    },
    ChangeTypeDateDelivery: function(val) {
      this.$emit('ChangeTypeDateDelivery', val);
    },
    ChangeSellerDelivery: function(event, action) {
      this.$emit('ChangeSellerDelivery', event, action);
    },
    getProducts: function(name) {
      this.$emit('getProducts', name);
    },
    drawChart(chartData, labels, labelstring) {
      var ctx = document.getElementById(this.iddelivery);
      this.myChart = new Chart(ctx, {
        type: 'doughnut',
        showTooltips: true,
        data: {
          labels: [
            'Shipped',
            'Postponed',
            'Unreachable',
            'Delivered',
            'Cancelled',
            'Refused',
          ],
          datasets: [
            {
              label: 'Total Orders',
              data: chartData.map(i => i.count),
              backgroundColor: [
                '#4299e1',
                '#f6ad55',
                '#cd772e',
                '#48bb78',
                '#f56565',
                '#9329a8',
              ],
              borderColor: [
                '#4299e1',
                '#f6ad55',
                '#cd772e',
                '#48bb78',
                '#f56565',
                '#9329a8',
              ],
              weight: 2,
            },
          ],
        },
        options: {
          responsive: true,
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var allData = data.datasets[tooltipItem.datasetIndex].data;
                var tooltipLabel = data.labels[tooltipItem.index];
                var tooltipData = allData[tooltipItem.index];
                var total = 0;
                for (var i in allData) {
                  total += allData[i];
                }
                var tooltipPercentage = Math.round((tooltipData / total) * 100);
                return (
                  tooltipLabel +
                  ': ' +
                  tooltipData +
                  ' (' +
                  tooltipPercentage +
                  '%)'
                );
              },
            },
          },
          legend: {
            display: false,
            position: 'right',
            labels: {
              boxWidth: 20,
              fontColor: '#111',
              padding: 15,
            },
          }
        },
      });
    },
  }
};
</script>

<style scoped>
body {
  font-family: 'IBM Plex Mono', sans-serif;
}
[x-cloak] {
  display: none;
}
.vs__dropdown-toggle {
  border: none;
}
.text-refused {
  color: #9329a8;
}
.text-unrach {
  color: #cd772e;
}
.line {
  background: repeating-linear-gradient(
    to bottom,
    #eee,
    #eee 1px,
    #fff 1px,
    #fff 8%
  );
}
.tick {
  background: repeating-linear-gradient(
    to right,
    #eee,
    #eee 1px,
    #fff 1px,
    #fff 5%
  );
}
</style>
